module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/default-thumbnail-small.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"365a6cb4dcc27689069a5e06040f0213"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
